import { render, staticRenderFns } from "./RoomEdit.vue?vue&type=template&id=bc4a3702&"
import script from "./RoomEdit.vue?vue&type=script&lang=js&"
export * from "./RoomEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoomEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports